import { SettingConst } from '@faire/web-api--source/types';

/**
 * The time in milliseconds that user hovers a brand link on a product tile before speculating
 */
export const BRAND_PAGE_PRODUCT_TILE_SPECULATION_HOVER_THRESHOLD =
  'BRAND_PAGE_PRODUCT_TILE_SPECULATION_HOVER_THRESHOLD' as SettingConst<
    'BRAND_PAGE_PRODUCT_TILE_SPECULATION_HOVER_THRESHOLD',
    number,
    'RETAILER'
  >;
